"use client";

import { useSyncExternalStore } from "react";

import {
  getGlobalPreferencesSnapshot,
  type GlobalPreferences,
} from "@/lib/global-preferences";

function subscribe(onStoreChange: () => void) {
  window.addEventListener("tairoh-global-preferences", onStoreChange);
  window.addEventListener("storage", onStoreChange);
  return () => {
    window.removeEventListener("tairoh-global-preferences", onStoreChange);
    window.removeEventListener("storage", onStoreChange);
  };
}

function getSnapshot(): GlobalPreferences {
  return getGlobalPreferencesSnapshot();
}

export function useGlobalPreferences() {
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
}
